import React from 'react'
import PropTypes from 'prop-types'
import { Grid, LinkDocument } from './AttachFiles.styles'

/**
 * The AttachedFilesBlue's component.
 */
const AttachedFilesBlue = props => {
  const { id, name, onDownloadFile } = props

  const handleDownloadFile = () => onDownloadFile({ id, name })

  return (
    <Grid container margin="0 0 4px">
      <LinkDocument onClick={handleDownloadFile}>{name}</LinkDocument>
    </Grid>
  )
}

AttachedFilesBlue.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onDownloadFile: PropTypes.func.isRequired
}

export default AttachedFilesBlue
